import { useCallback, useEffect, useState } from 'react';
import './carga.css'
import axios from 'axios';
export default function PlanillaReclamos({ reclamo, carga4, denuncia }) {
    const [cargando, setCargando] = useState(false)
    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }
    const [reclamoUpdate, setReclamoUpdate] = useState({});
    useEffect(() => {
        if (reclamo) {
            setReclamoUpdate({
                NRO: reclamo.NRO,
                ASEGURADO: reclamo.ASEGURADO,
                CONDUCTOR: reclamo.CONDUCTOR,
                COBERTURA: reclamo.COBERTURA,
                REG_HABILITANTE: reclamo.REG_HABILITANTE,
                POLIZA: reclamo.POLIZA,
                STROS_ANTERIORES: reclamo.STROS_ANTERIORES,
                FECHA_DEL_SINIESTRO: reclamo.FECHA_DEL_SINIESTRO,
                FECHA_DEL_3RO: reclamo.FECHA_DEL_3RO,
                DENUNCIA_POLICIAL: reclamo.DENUNCIA_POLICIAL,
                PRESUPUESTO: reclamo.PRESUPUESTO,
                PRESUPUESTO_2: reclamo.PRESUPUESTO_2,
                CARTA_FRANQUICIA: reclamo.CARTA_FRANQUICIA,
                CERTIFICADO_COBERTURA: reclamo.CERTIFICADO_COBERTURA,
                VTV: reclamo.VTV,
                PRIORIDAD_DE_PASO: reclamo.PRIORIDAD_DE_PASO,
                RESPONSABILIDAD: reclamo.RESPONSABILIDAD,
                TITULARIDAD: reclamo.TITULARIDAD,
                DESTRUCCION_TOTAL: reclamo.DESTRUCCION_TOTAL,
                PPTO_DEL_3RO: reclamo.PPTO_DEL_3RO,
                INSPECCION: reclamo.INSPECCION,
                PORCENTAJE: reclamo.PORCENTAJE,
                PORCENTAJE_DE_INSP: reclamo.PORCENTAJE_DE_INSP,
                PORC_INSP_CC: reclamo.PORC_INSP_CC,
                HONORARIOS: reclamo.HONORARIOS,
                TOTAL_HONORARIOS: reclamo.TOTAL_HONORARIOS,
                ES_CC: reclamo.ES_CC,
                PORCENTAJE_CC: reclamo.PORCENTAJE_CC,
                TOTAL_HONORARIOS_CC: reclamo.TOTAL_HONORARIOS_CC,
                LESIONES: reclamo.LESIONES,
                HIST_CLINICA: reclamo.HIST_CLINICA,
                DEN_POL: reclamo.DEN_POL,
                CAUSA_PEN: reclamo.CAUSA_PEN,
                FOT_LES: reclamo.FOT_LES,
                PRETENSION: reclamo.PRETENSION,
                DOCUMENTACION_OBSERVACIONES: reclamo.DOCUMENTACION_OBSERVACIONES,
                TITULAR: reclamo.TITULAR,
                CONDUCTOR_TER: reclamo.CONDUCTOR_TER,
                NOMBRE_DEL_APODERADO: reclamo.NOMBRE_DEL_APODERADO,
                DATOS_DEL_VH_DEL_TERCERO: reclamo.DATOS_DEL_VH_DEL_TERCERO,
                QUIEN_LO_ARMO: reclamo.QUIEN_LO_ARMO,
                FECHA: reclamo.FECHA,
            });
        }
    }, [reclamo]);
    const handleCheckboxChange = (value) => {
        setReclamoUpdate((prevState) => ({
            ...prevState,
            ES_CC: prevState.ES_CC === value ? "" : value
        }));
    };
    const totalInspeccion = reclamoUpdate.INSPECCION && reclamoUpdate.PORCENTAJE ? (reclamoUpdate.INSPECCION * reclamoUpdate.PORCENTAJE) / 100 : null;
    const porcentajeInspCc = reclamoUpdate.ES_CC === 'ES CC' && reclamoUpdate.PORCENTAJE && reclamoUpdate.PORCENTAJE_CC ? (reclamoUpdate.PORCENTAJE * reclamoUpdate.PORCENTAJE_CC) / 100 : null;
    const totalHonorarios = totalInspeccion && reclamoUpdate.HONORARIOS ? (totalInspeccion * reclamoUpdate.HONORARIOS) / 100 : null;
    const totalHonorariosCC = porcentajeInspCc !== null && reclamoUpdate.HONORARIOS ? porcentajeInspCc + (porcentajeInspCc * reclamoUpdate.HONORARIOS / 100) : null;
    const actualizar = useCallback(async (e) => {
        e.preventDefault()
        setCargando(true)
        await axios.post(`https://back.agsseguros.online/api/planillaReclamos/update`, {
            id: reclamo.ID,
            nroStro: reclamoUpdate.NRO ? reclamoUpdate.NRO : denuncia.nroStro,
            pza: reclamoUpdate.POLIZA ? reclamoUpdate.POLIZA : denuncia.pza,
            asegurado: reclamoUpdate.ASEGURADO,
            conductor: reclamoUpdate.CONDUCTOR,
            fechaStro: reclamoUpdate.FECHA_DEL_SINIESTRO,
            strosAnteriores: reclamoUpdate.STROS_ANTERIORES,
            cobertura: reclamoUpdate.COBERTURA,
            reg_habilitante: reclamoUpdate.REG_HABILITANTE,
            fecha_del_3ro: reclamoUpdate.FECHA_DEL_3RO,
            denuncia_policial: reclamoUpdate.DENUNCIA_POLICIAL,
            presupuesto: reclamoUpdate.PRESUPUESTO,
            presupuesto_2: reclamoUpdate.PRESUPUESTO_2,
            carta_franquicia: reclamoUpdate.CARTA_FRANQUICIA,
            certificado_cobertura: reclamoUpdate.CERTIFICADO_COBERTURA,
            vtv: reclamoUpdate.VTV,
            prioridad_de_paso: reclamoUpdate.PRIORIDAD_DE_PASO,
            responsabilidad: reclamoUpdate.RESPONSABILIDAD,
            titularidad: reclamoUpdate.TITULARIDAD,
            destruccion_total: reclamoUpdate.DESTRUCCION_TOTAL,
            ppto_del_3ro: reclamoUpdate.PPTO_DEL_3RO,
            inspeccion: reclamoUpdate.INSPECCION,
            porcentaje: reclamoUpdate.PORCENTAJE,
            porcentaje_de_insp: totalInspeccion,
            porc_insp_cc: porcentajeInspCc,
            honorarios: reclamoUpdate.HONORARIOS,
            total_honorarios: totalHonorarios,
            es_cc: reclamoUpdate.ES_CC,
            porcentaje_cc: reclamoUpdate.PORCENTAJE_CC,
            total_honorarios_cc: totalHonorariosCC,
            lesiones: reclamoUpdate.LESIONES,
            hist_clinica: reclamoUpdate.HIST_CLINICA,
            den_pol: reclamoUpdate.DENUNCIA_POLICIAL,
            causa_pen: reclamoUpdate.CAUSA_PEN,
            fot_les: reclamoUpdate.FOT_LES,
            pretension: reclamoUpdate.PRETENSION,
            documentacion_observaciones: reclamoUpdate.DOCUMENTACION_OBSERVACIONES,
            titular: reclamoUpdate.TITULAR,
            conductor_ter: reclamoUpdate.CONDUCTOR_TER,
            nombre_del_apoderado: reclamoUpdate.NOMBRE_DEL_APODERADO,
            datos_del_vh_del_tercero: reclamoUpdate.DATOS_DEL_VH_DEL_TERCERO,
            quien_lo_armo: reclamoUpdate.QUIEN_LO_ARMO,
            fecha: reclamoUpdate.FECHA
        }
        ).then(async (response) => {
            window.location.reload()
        })
    }, [reclamoUpdate, reclamo]);
    const NRO = reclamoUpdate.NRO !== null ? reclamoUpdate.NRO : (denuncia?.nroStro ?? '');
    const generarPdf = async (e) => {
        window.open(
            `https://agsseguros.online/ca/?NRO=${NRO}&ASEG=${reclamoUpdate.ASEGURADO ?? ''}&COB=${reclamoUpdate.COBERTURA ?? ''}&CON=${reclamoUpdate.CONDUCTOR ?? ''}&REG=${reclamoUpdate.REG_HABILITANTE ?? ''}&PZA=${reclamoUpdate.POLIZA ?? ''}&STR=${reclamoUpdate.STROS_ANTERIORES ?? ''}&FST=${reclamoUpdate.FECHA_DEL_SINIESTRO ?? ''}&FST3=${reclamoUpdate.FECHA_DEL_SINIESTRO ?? ''}&DP=${reclamoUpdate.DENUNCIA_POLICIAL ?? ''}&CER=${reclamoUpdate.CERTIFICADO_COBERTURA ?? ''}&PPTO=${reclamoUpdate.PRESUPUESTO ?? ''}&PPTO2=${reclamoUpdate.PRESUPUESTO_2 ?? ''}&CF=${reclamoUpdate.CARTA_FRANQUICIA ?? ''}&VTV=${reclamoUpdate.VTV ?? ''}&PRI=${reclamoUpdate.PRIORIDAD_DE_PASO ?? ''}&RESP=${reclamoUpdate.RESPONSABILIDAD ?? ''}&TT=${reclamoUpdate.TITULARIDAD ?? ''}&DT=${reclamoUpdate.DESTRUCCION_TOTAL ?? ''}&P3RO=${reclamoUpdate.PPTO_DEL_3RO ?? ''}&INS=${reclamoUpdate.INSPECCION ?? ''}&PINS=${reclamoUpdate.PORCENTAJE ?? ''}&TINSP=${totalInspeccion ?? ''}&PIC=${porcentajeInspCc ?? ''}&HON=${reclamoUpdate.HONORARIOS ?? ''}&THON=${totalHonorarios ?? ''}&ECC=${reclamoUpdate.ES_CC ?? ''}&PCC=${reclamoUpdate.PORCENTAJE_CC ?? ''}&THCC=${totalHonorariosCC ?? ''}&LES=${reclamoUpdate.LESIONES ?? ''}&HIST=${reclamoUpdate.HIST_CLINICA ?? ''}&CAUS=${reclamoUpdate.CAUSA_PEN ?? ''}&DENP=${reclamoUpdate.DENUNCIA_POLICIAL ?? ''}&FOTL=${reclamoUpdate.FOT_LES ?? ''}&PRET=${reclamoUpdate.PRETENSION ?? ''}&DOC=${reclamoUpdate.DOCUMENTACION_OBSERVACIONES ?? ''}&TT2=${reclamoUpdate.TITULAR ?? ''}&CON2=${reclamoUpdate.CONDUCTOR_TER ?? ''}&NAP=${reclamoUpdate.NOMBRE_DEL_APODERADO ?? ''}&VH3=${reclamoUpdate.DATOS_DEL_VH_DEL_TERCERO ?? ''}&FIR=${reclamoUpdate.QUIEN_LO_ARMO ?? ''}`,

            "_blank"
        );
        await actualizar(e);
    };
    return (
        <>
            {carga4 ?
                (reclamo !== '' ?
                    <div>
                        <div className="row">
                            <div className="col">
                                <label className="mb-1">NRO STRO</label>
                                <input type="number" class="form-control w-50" value={reclamoUpdate.NRO ? reclamoUpdate.NRO : denuncia.nroStro} disabled />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">ASEGURADO</label>
                                <input type="text" class="form-control" value={reclamoUpdate.ASEGURADO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, ASEGURADO: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">COBERTURA</label>
                                <select className="form-select w-50" value={reclamoUpdate.COBERTURA}
                                    onChange={(e) => setReclamoUpdate((prevState) => ({
                                        ...prevState,
                                        COBERTURA: e.target.value
                                    }))}>
                                    <option value=""></option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">CONDUCTOR</label>
                                <input type="text" class="form-control" value={reclamoUpdate.CONDUCTOR} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, CONDUCTOR: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">REGISTRO HABILITANTE</label>
                                <select className="form-select w-50" value={reclamoUpdate.REG_HABILITANTE}
                                    onChange={(e) => setReclamoUpdate((prevState) => ({
                                        ...prevState,
                                        REG_HABILITANTE: e.target.value
                                    }))}>
                                    <option value=""></option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">PÓLIZA</label>
                                <input type="number" class="form-control w-50" value={reclamoUpdate.POLIZA ? reclamoUpdate.POLIZA : denuncia.pza} disabled />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">STROS ANTERIORES</label>
                                <select className="form-select w-50" value={reclamoUpdate.STROS_ANTERIORES}
                                    onChange={(e) => setReclamoUpdate((prevState) => ({
                                        ...prevState,
                                        STROS_ANTERIORES: e.target.value
                                    }))}>
                                    <option value=""></option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <hr className='mt-4 mb-4' />


                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">FECHA STRO</label>
                                <input type="date" name="" id="" className='form-control' value={reclamoUpdate.FECHA_DEL_SINIESTRO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, FECHA_DEL_SINIESTRO: e.target.value }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">FECHA STRO 3RO</label>
                                <input type="date" name="" id="" className='form-control' value={reclamoUpdate.FECHA_DEL_3RO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, FECHA_DEL_3RO: e.target.value }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">DENUNCIA POLICIAL</label>
                                <input type="text" class="form-control" value={reclamoUpdate.DENUNCIA_POLICIAL} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, DENUNCIA_POLICIAL: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">CERTIF COBERTURA</label>
                                <input type="text" class="form-control" value={reclamoUpdate.CERTIFICADO_COBERTURA} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, CERTIFICADO_COBERTURA: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">PRESUPUESTO</label>
                                <input type="text" class="form-control" value={reclamoUpdate.PRESUPUESTO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, PRESUPUESTO: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">PRESUPUESTO 2</label>
                                <input type="text" class="form-control" value={reclamoUpdate.PRESUPUESTO_2} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, PRESUPUESTO_2: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">CARTA FRANQUICIA</label>
                                <input type="text" class="form-control" value={reclamoUpdate.CARTA_FRANQUICIA} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, CARTA_FRANQUICIA: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">VTV</label>
                                <input type="text" class="form-control" value={reclamoUpdate.VTV} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, VTV: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">PRIORIDAD PASO</label>
                                <input type="text" class="form-control" value={reclamoUpdate.PRIORIDAD_DE_PASO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, PRIORIDAD_DE_PASO: e.target.value, }))} />
                            </div>
                            <div className='col'>
                                <label className='mb-1'>RESPONSABILIDAD</label>
                                <input type="text" class="form-control" value={reclamoUpdate.RESPONSABILIDAD} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, RESPONSABILIDAD: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">TITULARIDAD</label>
                                <input type="text" class="form-control" value={reclamoUpdate.TITULARIDAD} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, TITULARIDAD: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">DESTRUCCION TOTAL</label>
                                <input type="text" class="form-control" value={reclamoUpdate.DESTRUCCION_TOTAL} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, DESTRUCCION_TOTAL: e.target.value, }))} />
                            </div>
                        </div>
                        <hr className='mt-4 mb-4' />


                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">PPTO DEL 3R0</label>
                                <input type="number" class="form-control" value={reclamoUpdate.PPTO_DEL_3RO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, PPTO_DEL_3RO: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">INSPECCIÓN</label>
                                <input type="number" class="form-control" value={reclamoUpdate.INSPECCION} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, INSPECCION: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">PORCENTAJE</label>
                                <input type="number" class="form-control" value={reclamoUpdate.PORCENTAJE} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, PORCENTAJE: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">TOTAL DE INSPECCION</label>
                                <div>{reclamoUpdate.INSPECCION && reclamoUpdate.PORCENTAJE ? totalInspeccion : null}</div>
                            </div>
                            <div className="col">
                                <label className="mb-1">% INSP / CC</label>
                                <div>{reclamoUpdate.ES_CC === 'ES CC' && reclamoUpdate.PORCENTAJE && reclamoUpdate.PORCENTAJE_CC ? porcentajeInspCc : null}</div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">HONORARIOS %</label>
                                <input type="number" class="form-control" value={reclamoUpdate.HONORARIOS} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, HONORARIOS: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">TOTAL HONORARIOS</label>
                                <div>{totalInspeccion && reclamoUpdate.HONORARIOS ? totalHonorarios : null}</div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">CULPA CONCURRENTE?</label>
                                <div className="d-flex gap-5">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={reclamoUpdate.ES_CC === "ES CC"}
                                            onChange={() => handleCheckboxChange("ES CC")}
                                        />
                                        <label className="form-check-label">ES CC</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={reclamoUpdate.ES_CC === "NO"}
                                            onChange={() => handleCheckboxChange("NO")}
                                        />
                                        <label className="form-check-label">NO</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <label className="mb-1">PORCENTAJE CC</label>
                                <input type="number" class="form-control" value={reclamoUpdate.PORCENTAJE_CC} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, PORCENTAJE_CC: e.target.value, }))} />
                            </div>
                            <div className="col">
                                <label className="mb-1">TOTAL HONORARIOS CC</label>
                                <div>{reclamoUpdate.ES_CC === 'ES CC' && reclamoUpdate.PORCENTAJE && reclamoUpdate.PORCENTAJE_CC && reclamoUpdate.HONORARIOS ? totalHonorariosCC : null}</div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">LESIONES</label>
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="lesionesCheckbox"
                                        checked={reclamoUpdate.LESIONES === "SI"}
                                        onChange={(e) => setReclamoUpdate((prevState) => ({
                                            ...prevState,
                                            LESIONES: e.target.checked ? "SI" : ""
                                        }))}
                                    />
                                    <label className="form-check-label" htmlFor="lesionesCheckbox">SI</label>

                                </div>

                            </div>
                            {reclamoUpdate.LESIONES === 'SI' ?
                                <div className="col">
                                    <label className="mb-1">Lesiones</label>
                                    <div className="d-flex gap-3">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="histClinicaCheckbox"
                                                checked={reclamoUpdate.HIST_CLINICA === "SI"}
                                                onChange={(e) => setReclamoUpdate((prevState) => ({
                                                    ...prevState,
                                                    HIST_CLINICA: e.target.checked ? "SI" : ""
                                                }))}
                                            />
                                            <label className="form-check-label" htmlFor="histClinicaCheckbox">HIST CLINICA</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="denPolCheckbox"
                                                checked={reclamoUpdate.DEN_POL === "SI"}
                                                onChange={(e) => setReclamoUpdate((prevState) => ({
                                                    ...prevState,
                                                    DEN_POL: e.target.checked ? "SI" : ""
                                                }))}
                                            />
                                            <label className="form-check-label" htmlFor="denPolCheckbox">DEN POL</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="causaPenCheckbox"
                                                checked={reclamoUpdate.CAUSA_PEN === "SI"}
                                                onChange={(e) => setReclamoUpdate((prevState) => ({
                                                    ...prevState,
                                                    CAUSA_PEN: e.target.checked ? "SI" : ""
                                                }))}
                                            />
                                            <label className="form-check-label" htmlFor="causaPenCheckbox">CAUSA PEN</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="fotLesCheckbox"
                                                checked={reclamoUpdate.FOT_LES === "SI"}
                                                onChange={(e) => setReclamoUpdate((prevState) => ({
                                                    ...prevState,
                                                    FOT_LES: e.target.checked ? "SI" : ""
                                                }))}
                                            />
                                            <label className="form-check-label" htmlFor="fotLesCheckbox">FOT LES</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="pretensionCheckbox"
                                                checked={reclamoUpdate.PRETENSION === "SI"}
                                                onChange={(e) => setReclamoUpdate((prevState) => ({
                                                    ...prevState,
                                                    PRETENSION: e.target.checked ? "SI" : ""
                                                }))}
                                            />
                                            <label className="form-check-label" htmlFor="pretensionCheckbox">PRETENSION</label>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">DOCUMENTACIÓN/OBSERVACIONES</label>
                                <textarea
                                    className="form-control"
                                    style={{ height: '200px' }}
                                    value={reclamoUpdate.DOCUMENTACION_OBSERVACIONES}
                                    onChange={(e) =>
                                        setReclamoUpdate((prevState) => ({
                                            ...prevState,
                                            DOCUMENTACION_OBSERVACIONES: e.target.value,
                                        }))
                                    }
                                />

                            </div>
                        </div>
                        <hr className='mt-4 mb-4' />


                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">TITULAR</label>
                                <input type="text" class="form-control" value={reclamoUpdate.TITULAR} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, TITULAR: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">CONDUCTOR</label>
                                <input type="text" class="form-control" value={reclamoUpdate.CONDUCTOR_TER} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, CONDUCTOR_TER: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">NOMBRE APODERADO</label>
                                <input type="text" class="form-control" value={reclamoUpdate.NOMBRE_DEL_APODERADO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, NOMBRE_DEL_APODERADO: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">DATOS DEL VH DEL TERCERO</label>
                                <input type="text" class="form-control" value={reclamoUpdate.DATOS_DEL_VH_DEL_TERCERO} onChange={(e) => setReclamoUpdate((prevState) => ({ ...prevState, DATOS_DEL_VH_DEL_TERCERO: e.target.value, }))} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <label className="mb-1">QUIEN LO ARMO</label>
                                <select className="form-select w-50" value={reclamoUpdate.QUIEN_LO_ARMO}
                                    onChange={(e) => setReclamoUpdate((prevState) => ({
                                        ...prevState,
                                        QUIEN_LO_ARMO: e.target.value
                                    }))}>
                                    <option value=""></option>
                                    <option value="DM">DM</option>
                                    <option value="DD">DD</option>
                                    <option value="OC">OC</option>
                                    <option value="JG">JG</option>
                                </select>
                            </div>
                        </div>
                        <hr className='mt-4 mb-4' />


                        <div className='mt-5 mb-3 center gap-3'>
                            <button className='btn btn-primary' onClick={(e) => actualizar(e)}>Actualizar</button>
                            <button className="btn btn-primary" onClick={(e) => generarPdf(e)}>Generar PDF</button>
                        </div>
                        {cargando ? <div className="center"><div class="spinner-border text-success center" role="status"><span class="visually-hidden center">Loading...</span></div></div> : null}
                    </div>
                    : <h2 className=''>El reclamo aun no ha sido registrado en la tabla. <br></br>Favor de esperar 15 minutos</h2>
                ) : <div className="center"><div class="spinner-border text-success center" role="status"><span class="visually-hidden center">Loading...</span></div></div>}
        </>
    );
}